import React, { ChangeEvent, useCallback, useState } from "react";
import { Alerts } from "@components/common/AlertModal";
import styled from "@emotion/styled";
import { Caption1, colors } from "@utils/ui_palette";
import Input from "@components/common/Input";
import axios, { AxiosError } from "axios";
import userSlice from "../slices/user";
import { useAppDispatch } from "../store";

function Login() {
  const dispatch = useAppDispatch();
  const [id, setId] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [errorMessage, setErrorMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(false);
  const isGoNext = id !== "" && password !== "";

  const onIdChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;

      setId(value.toString().trim());
    },
    [setId]
  );

  const onPasswordChange = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      const { value } = event.target;
      setPassword(value.toString().trim());
    },
    [setPassword]
  );

  const onSubmint = useCallback(async () => {
    if (!id && !id.trim()) {
      Alerts.show({
        title: "Please enter your ID",
      });
    }

    if (!password && !password.trim()) {
      Alerts.show({
        title: "Please enter your password",
      });
    }

    setLoading(true);

    // ${process.env.API_URL}
    try {
      const { data } = await axios.post(
        `${process.env.REACT_APP_API}/auth/admin-login`,
        {
          password,
          login_id: id,
        }
      );

      console.log(data);
      localStorage.setItem("refreshToken", data.refreshToken);
      dispatch(
        userSlice.actions.setUserInfo({
          ...data.user,
          accessToken: data.accessToken,
        })
      );
    } catch (error) {
      const errorResponse = (error as AxiosError).response;

      if (errorResponse && (errorResponse.data as any).message) {
        setErrorMessage((errorResponse.data as any).message);
      }
    } finally {
      setLoading(false);
    }
  }, [dispatch, id, password]);

  return (
    <Container>
      <LogoBox>
        <Logo src="/img/img_login_logo.png" />
      </LogoBox>
      <Form>
        <InputBox>
          <Input
            type="text"
            placeholder="ID"
            value={id}
            onChange={onIdChange}
          />
        </InputBox>

        <InputBox>
          <Input
            type="password"
            placeholder="Password"
            value={password}
            onChange={onPasswordChange}
          />
        </InputBox>
      </Form>

      {errorMessage !== "" && (
        <Caption1 color={colors.Error20} align="left" marginTop={10}>
          {errorMessage}
        </Caption1>
      )}

      <LoginButton disabled={!isGoNext || loading} onClick={onSubmint}>
        Login
      </LoginButton>
    </Container>
  );
}

const Container = styled.div`
  width: 400px;
  margin: 0 auto;
  padding-top: 80px;
`;

const LogoBox = styled.div`
  margin-top: 200px;
  width: 150px;
  margin-bottom: 40px;
`;

const Logo = styled("img")`
  width: 100%;
`;

const Form = styled.form``;

const InputBox = styled.div`
  margin-top: 20px;
`;

const LoginButton = styled.button`
  width: 100%;
  height: 50px;
  margin-top: 40px;
  background-color: ${colors.Primary50};
  border-radius: 10px;
  color: ${colors.White};
  font-size: 14px;
  border: 0;
  cursor: pointer;

  &:disabled {
    background-color: ${colors.Gray50};
  }
`;

export default Login;
